import { render, staticRenderFns } from "./CheckboxLoadSirv.vue?vue&type=template&id=d507d4ae&"
import script from "./CheckboxLoadSirv.vue?vue&type=script&lang=js&"
export * from "./CheckboxLoadSirv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports